import { useEffect, useState } from "react";
import TrainingService from "../Service/TrainingService";
import GetAllFormaView from "../Vue/Pages/GetAllFormaView";
import Header from "../Vue/Components/Header";

const GetAllFormationController = () => {
  const [incendie, setIncendie] = useState([]);
  const [secourisme, setSecourisme] = useState([]);
  const [prevention, setPrevention] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrainings();
  }, [])

  const fetchTrainings = async () => {
    try {
      let response = await TrainingService.fetchTrainings();
      console.log(response);
      let incendieList = [];
      let secourismeList = [];
      let preventionList = [];
      response.data.trainings.map(training => {
        if (training.training_cycle.id == 1 && training.public_display == true && !training.name.toLowerCase().includes("intra")) {
          incendieList.push(training);
        }else if (training.training_cycle.id == 2 && training.public_display == true && !training.name.toLowerCase().includes("intra")) {
          secourismeList.push(training);
        }else if (training.public_display == true && !training.name.toLowerCase().includes("intra")) {
          preventionList.push(training);
        } else if (training.name.toLowerCase().includes("prap")){
          preventionList.push(training);
        }
      });
      setIncendie(incendieList);
      setSecourisme(secourismeList);
      setPrevention(preventionList);
    } catch (error) {
      console.log("erreur"+error);
    }finally {
      setLoading(false); // Set loading to false after fetching data
    }
  }
  return (GetAllFormaView(incendie, secourisme, prevention, loading))
}

export default GetAllFormationController;